// src/components/CongratulationsDialog.js

import React from 'react';

function CongratulationsDialog({ isOpen, onClose, numTries, answer }) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white rounded-lg shadow-lg p-8 w-11/12 max-w-md">
        <h2 className="text-2xl font-bold mb-4">Congratulations!</h2>
        <p className="mb-4">
          You guessed the character <strong>{answer.name}</strong> correctly!
        </p>
        <p className="mb-4">
          It took you <strong>{numTries}</strong> tries.
        </p>
        <button
          onClick={onClose}
          className="px-4 py-2 bg-palette-lighter-blue text-white rounded hover:bg-palette-light-rose hover:text-black focus:outline-none focus:ring-2 focus:ring-indigo-500"
        >
          Close
        </button>
      </div>
    </div>
  );
}

export default CongratulationsDialog;
